export const navigationLinks = [
  {
    label: 'About',
    href: '#about'
  },
  {
    label: 'Background',
    href: '#education'
  },
  /*{
    label: 'Certification',
    href: '#certification'
  },*/
  {
    label: 'Projects',
    href: '#projects'
  },
  {
    label: 'Contact',
    href: '#contact'
  }
];

export const footerLinks = [
  {
    label: 'About',
    href: '#about'
  },
  {
    label: 'Background',
    href: '#education'
  },
  
  {
    label: 'Projects',
    href: '#projects'
  },
  {
    label: 'Contact',
    href: '#contact'
  }
];

export const brandName = 'Kevin Maoty';

export const footerTitleJob = 'Full Stack Developer';